import React from "react";
import { SxStyleProp } from "theme-ui";
import { BoxProps } from "rebass";
import Button from "./Button";

const variants = {
  primary: {
    color: "white",
    bg: "primary",
  },
  outline: {
    color: "primary",
    bg: "white",
  },
};

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  sx?: SxStyleProp;
  css?: any;
  variant?: keyof typeof variants;
}

const RoundButton: React.FunctionComponent<Props & BoxProps> = ({
  sx,
  variant = "primary",
  children,
  ...restProps
}) => {
  return (
    <Button
      sx={{
        justifyContent: "center",
        border: "1px solid",
        borderRadius: "full",
        minWidth: "2.5rem",
        minHeight: "2.5rem",
        p: 0,

        ...variants[variant],
        ...(sx as any),
      }}
      {...restProps}
    >
      {children}
    </Button>
  );
};

export default RoundButton;
